import { useRef } from "react";
import { useDropzone } from "react-dropzone";
import { Box, Typography } from "../../../components";

const SelecionarArquivo = ({ arquivo, setArquivo }) => {
  const arquivoUpload = useRef(null);
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: {
      "text/csv": [".csv"],
      "application/vnd.ms-excel": [".xls"],
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [
        ".xlsx",
      ],
    },
    onDrop: (arquivosAceitos) => {
      setArquivo(arquivosAceitos[0]);
    },
  });

  return (
    <Box
      {...getRootProps()}
      sx={{
        width: "100%",
        height: "90%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        marginTop: "1em",
        border:
          isDragActive || arquivo ? "2px dashed grey" : "2px solid transparent",
        borderRadius: 2,
        padding: 2,
        backgroundColor: isDragActive || arquivo ? "#e3f2fd" : "#fafafa",
        ":hover": { backgroundColor: "#e3f2fd", border: "2px dashed grey" },
        cursor: "pointer",
      }}
      onClick={() => arquivoUpload.current.click()}
    >
      <input
        {...getInputProps()}
        type="file"
        style={{ display: "none" }}
        ref={arquivoUpload}
        onChange={(event) => setArquivo(event.target.files[0])}
      />
      {arquivo && (
        <i
          className="mb-2 ph-bold ph-check-circle"
          style={{ fontSize: 50, color: "#43a047" }}
        />
      )}
      <h4 style={{ fontWeight: 800, margin: 0 }}>
        {arquivo
          ? "Arquivo Selecionado!"
          : "Arraste e solte ou Clique aqui para importar arquivo CSV/XLS"}
      </h4>
      {arquivo?.name && (
        <div className="mt-2">
          <Typography>{arquivo.name}</Typography>
        </div>
      )}
    </Box>
  );
};

export default SelecionarArquivo;
